import { render, staticRenderFns } from "./HomeInvestigateTabs.vue?vue&type=template&id=47cf6f39&scoped=true&"
import script from "./HomeInvestigateTabs.vue?vue&type=script&lang=tsx&"
export * from "./HomeInvestigateTabs.vue?vue&type=script&lang=tsx&"
import style0 from "./HomeInvestigateTabs.vue?vue&type=style&index=0&id=47cf6f39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf6f39",
  null
  
)

export default component.exports